export enum PraiseTabs {
  'GIVEN' = 'Given',
  'RECEIVED' = 'Received',
}
